export async function pollForNewMessages(
  proxyUrl: string,
  threadId: string,
  currentConversation: any[],
  attemptCount: number = 0,
): Promise<any> {
  if (attemptCount > 20) {
    throw new Error('Timeout while waiting for new messages');
  }

  const response = await fetch(proxyUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path: `/threads/${threadId}/messages`,
      method: 'GET',
      headers: {
        'OpenAI-Beta': 'assistants=v1',
      },
    }),
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const responseBody = await response.json();
  const newMessages = responseBody.data.filter((msg: any) => {
    if (!msg.content[0]?.text?.value) {
      console.warn(`Empty message received: ${msg.id}`);
      return false;
    }
    return !currentConversation.some((currentMsg) => currentMsg.id === msg.id);
  });

  if (newMessages.length > 0) {
    // New messages found. Our wait is over.
    return responseBody.data;
  }

  // Give the assistant some time.
  const delayMs = 1000;
  await new Promise((resolve) => setTimeout(resolve, delayMs));

  // Try again.
  return await pollForNewMessages(
    proxyUrl,
    threadId,
    currentConversation,
    attemptCount + 1,
  );
}
